// extracted by mini-css-extract-plugin
export default {"wrapper":"ZI3UV","button":"qnlCN","text-centered":"JC06z"};